<style src="./loginPage.css" scoped></style>
<style src="./base.css" scoped></style>
<style>@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,400;0,800;1,800&display=swap');</style>


<template>
    <div id="container">
    <div id="container-inside">
      <div id="circle-small"></div>
      <div id="circle-medium"></div>
      <div id="circle-large"></div>
      <div id="circle-xlarge"></div>
      <div id="circle-xxlarge"></div>
    </div>
  <div class="login-container">
    <div class="login-box">
      <div>
        <h2 class="heading">
          Sign in
        </h2>
      </div>
      <form class="form" @submit.prevent="login">
        <input type="hidden" name="remember" value="true" />
        <div class="input-group">
          <div class="input-field">
            <label for="email-address" class="screen-reader">Email address</label>
            <input
              id="email-address"
              name="email"
              type="email"
              v-model="email"
              autocomplete="email"
              required
              placeholder="Email address"
            />
          </div>
          <div class="input-field">
            <label for="password" class="screen-reader">Password</label>
            <input
              id="password"
              name="password"
              type="password"
              v-model="password"
              autocomplete="current-password"
              required
              placeholder="Password"
            />
          </div>
        </div>
        <div>
          <button type="submit" class="login-button">
            Sign in
          </button>
        </div>
      </form>
      <p class="error-message" v-if="error">{{ error }}</p>
    </div>
  </div>
  </div>
</template>

<script>
import { signInWithEmailAndPassword } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { db, auth } from "../firebaseConfig";

export default {
  name: "AppLogin",
  data() {
    return {
      email: "",
      password: "",
      error: ""
    };
  },
  methods: {
    async login() {
      try {
        // 1. Sign in using Firebase Auth
        const userCredential = await signInWithEmailAndPassword(auth, this.email, this.password);
        const user = userCredential.user;
        
        // 2. Fetch the active account document from /active_accounts/{UID}
        const activeAccountRef = doc(db, "active_accounts", user.uid);
        const activeAccountSnap = await getDoc(activeAccountRef);
        if (!activeAccountSnap.exists()) {
          this.error = "Your account has not been activated by admin. Please contact support.";
          return;
        }
        
        // 3. Retrieve the userID field from the active account doc
        const activeAccountData = activeAccountSnap.data();
        const userID = activeAccountData.userID;
        if (!userID) {
          this.error = "Active account profile is missing the userID field.";
          return;
        }
        
        // 4. Fetch the corresponding user profile from /users/{userID}
        const userProfileRef = doc(db, "users", userID);
        const userProfileSnap = await getDoc(userProfileRef);
        if (!userProfileSnap.exists()) {
          this.error = "User profile not found.";
          return;
        }
        const profileData = userProfileSnap.data();
        console.log("User profile data:", profileData);
        
        // 5. Redirect based on the user's role (or privileges)
        this.error = "";
        const role = profileData.role;
        if (role === "admin") {
          this.$router.push("/profile/dashboard");
        } else if (role === "production") {
          this.$router.push("/profile/dashboard");
        } else {
          this.$router.push("/profile");
        }
      } catch (err) {
        console.error("Login error:", err);
        this.error = err.message;
      }
    },
    resetPassword() {
      // Implement your reset password logic here
    }
  }
};
</script>

<!-- Animated Background Styles -->
<style scoped>

</style>